import { createFileRoute } from "@tanstack/react-router";

import BookingSettingsPage from "@/admin/settings/booking-settings/page";

export const Route = createFileRoute("/app/$storeId/settings/booking-settings")({
    component: RouteComponent,
});

function RouteComponent() {
    return <BookingSettingsPage />;
}
